<template>
	<div class="side-window">
		<div class="side-window__header">
			<div class="side-window__title">{{ title }}</div>
			<icon-button-view class="side-window__prev" icon="previous" @click="$emit('pop')" />
			<icon-button-view class="side-window__prev desktop" icon="double_arrow_right" @click.stop="minimize" />
			<icon-button-view class="side-window__close" icon="close" @click="$emit('close')" />
		</div>
		<tabs-view v-if="tabs" :tabs="tabs" :active="active" @input="tabSelect" />
		<perfect-scrollbar class="side-window__content" :style="{
			top: tabs ? '100px' : '60px',
			bottom: this.$slots.footer ? '80px' : '0'
		}">
			<slot />
		</perfect-scrollbar>
		<div v-if="this.$slots.footer" class="side-window__footer">
			<slot name="footer" />
		</div>
	</div>
</template>

<script>
	import { bus } from '../bus'

	export default {
		data() {
			return {
				hidden: false
			};
		},
		props: {
			title: String,
			index: Number,
			tabs: Array,
			active: String,
		},
		methods: {
			tabSelect(name, tab) {
				this.$emit('tabSelect', name, tab);
			},
			minimize() {
				bus.$emit('minimize');
			}
		}
	}
</script>

<style lang="scss">
	.side-window {
		background-color: #15161a;
		/*border-left: 1px solid #cecece;*/
		top: 0;
		width: 500px;
		right: 0;
		bottom: 0;

		-webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);
		-moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);
		box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);

		&__content {
			position: absolute;
			color: white;
			width: 100%;
			left: 0;
			top: 60px;
			bottom: 0;

			overflow-y: auto;
			-webkit-overflow-scrolling: touch;
		}

		&__header {
			display: grid;
			grid-template-columns: auto 40px 40px 40px;
			grid-template-rows: 40px;
			padding: 10px 10px 10px 20px;
			background-color: #202127;
			color: white;
		}

		&__footer {
			padding: 20px;
			text-align: right;
			position: absolute;
			bottom: 0;
			width: 100%;

			& > div > div {
				display: inline-block;
				margin-left: 20px;
			}
		}

		&__title {
			line-height: 40px;
			font-size: 18px;
		}

		&__prev, &__close {
			& .icon-button__icon {
				fill: white;
			}
		}




		& > .tabs {
			background-color: #202127;
		}
	}

	.side-window {
		&__heading {
			height: 30px;
			line-height: 30px;
			position: relative;

			& > .switch {
				position: absolute;
				top: 5px;
				right: 0;
			}

			& > .icon-button {
				position: absolute;
				top: 15px;
				right: 10px;

				& > svg {
					fill: white;
				}
			}
		}

		&__heading.small {
			font-size: 12px;
		}

		&__footer > * {
			float: right;
		}
	}

	@media only screen and (max-width: 600px) {
		.side-window {
			max-width: 100%;

			&__header {
				grid-template-columns: auto 40px 40px;
			}

			& .desktop {
				display: none;
			}
		}
	}
</style>